<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>

<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title font">{{titulo}}</h3>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">

    <!-- Formulario de tarifa abierta-->
    <form class="form-modal py-3  flex-container" [formGroup]="formGroup">
      <div class="form-row">
        <div class="form-item flex-grow-1">
          <label for="year">Año <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input formControlName="year" id="year" placeholder="Año" matInput type="number" [min]="0">
              <mat-error *ngIf="controlHasError('year', 'required')">Campo obligatorio</mat-error>
              <mat-error *ngIf="formGroup.get('year')?.invalid && formGroup.get('year')?.touched">Año inválido (1900
                a 2500)
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="form-item flex-grow-1">
          <label for="valorTarifa">€/Kg <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input formControlName="valorTarifa" id="valorTarifa" placeholder="€/Kg" matInput type="text"
                appTreeDigitDecimalNumber>
              <mat-error *ngIf="controlHasError('valorTarifa', 'required')">Campo obligatorio</mat-error>
              <mat-error *ngIf="formGroup.get('valorTarifa')?.errors?.['maxDecimales']">
                Ingrese un máximo de 3 decimales
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="form-row pt-3">
        <div class="form-item flex-grow-1  fixed-width">
          <label for="codigoLer">Código LER y descripción de ENVALORA <span class="oblig">* </span><em
            *ngIf="formGroup.get('codigoLer')?.value?.peligrosidad === true" class="fas fa-skull-crossbones"
            style="color: #B80F61;" matTooltip="Envase de tipo peligroso"></em></label>
          <div class="custom-mat-form-field">
            <lib-ge-select-pagination class="lib-ge-select" [endPointFilter]="codigosLerEndpoint"
                                      [descripcion]="getLerDescription" [defaultFilter]=defaultFilter
                                      [formControlNameSelect]="getFormControl('codigoLer')" [objQueryName]="getObjectQuery"
                                      [placeHolder]="'-- Código LER y descripción de ENVALORA --'" [customClass]="rightHolder('codigoLer')">
            </lib-ge-select-pagination>
            <div class="ge-select-error">
              <mat-error class="ge-select-mat-error" *ngIf="selPaginatorHasError('codigoLer')">Campo obligatorio
              </mat-error>
            </div>
          </div>
        </div>
        <div class="form-item">
          <label for="grupoPeligrosidad">Peligrosidad <span class="oblig">*</span></label>
          <mat-form-field class="custom-mat-form-field" appearance="outline">
            <mat-select formControlName="peligrosidad" id="peligrosidad" placeholder="--">
              <mat-option [value]="true">Si</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
            <mat-error *ngIf="controlHasError('peligrosidad', 'required')">Campo obligatorio</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="form-row pt-3">
      </div>

    </form>


    <!-- FIN Formulario tarifa abierta -->
  </div>
  <div class="modal-footer actions">
    <div class="note">* Campos Obligatorios</div>
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" data-dismiss="modal" (click)="cerrar()"
        aria-label="Cancelar">Cancelar</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="guardar()"
        aria-label="Guardar">Guardar</button>
    </div>
  </div>
